import {
  CREATE_SR_DOCUMENT_LOCATION,
  DELETE_SR_DOCUMENT_LOCATION,
  ERROR_SR_DOCUMENT_LOCATION,
  SET_SR_DOCUMENT_LOCATIONS,
  SET_SR_DOCUMENT_LOCATION_OPTIONS,
  TOGGLE_SR_DOCUMENT_LOCATION,
  UNSET_SR_DOCUMENT_LOCATION_ACTION,
  UNSET_SR_DOCUMENT_LOCATION_OPTIONS,
  UNSET_ERROR_SR_DOCUMENT_LOCATION,
  UPDATE_SR_DOCUMENT_LOCATION,
} from 'actions/types'
import _ from 'lodash'
import moment from 'moment'
import { showAvailable } from 'utils/commonUtils'
import { selectObject } from 'utils/formUtils'

const INITIAL_STATE = {
  lastAction: null,
  locationsAvailable: {},
  locationOptions: [],
  locationErrors: [],
}

const srDocumentLocationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_SR_DOCUMENT_LOCATIONS:
      return {
        ...state,
        lastAction: 'fetch',
        locationsAvailable: _.mapKeys(action.payload, 'id'),
      }
    case SET_SR_DOCUMENT_LOCATION_OPTIONS:
      const options = selectObject(
        showAvailable(action.payload),
        action.currentSrDocumentLocation
          ? action.currentSrDocumentLocation.id
          : 0,
        action.noDefaultOptions ? false : true,
        'All Locations'
      )
      return { ...state, locationOptions: options }
    case UNSET_SR_DOCUMENT_LOCATION_OPTIONS:
      if (state.locationOptions) {
        return { ...state, locationOptions: [] }
      }
      return state
    case UNSET_SR_DOCUMENT_LOCATION_ACTION:
      return { ...state, lastAction: null }
    case CREATE_SR_DOCUMENT_LOCATION:
      const createdItem = action.payload.created_items[0]
      const { id } = createdItem
      const newState = {
        ...state,
        lastAction: 'create',
        locationsAvailable: {
          ...state.locationsAvailable,
          [id]: createdItem,
        },
      }
      return newState
    case UPDATE_SR_DOCUMENT_LOCATION:
      const updatedItem = (state.locationsAvailable[
        action.currentSrDocumentLocation.id
      ] = action.currentSrDocumentLocation)
      updatedItem.updated_at = moment.utc().format('YYYY-MM-DD HH:mm:ss')
      return {
        ...state,
        lastAction: 'edit',
        updatedItem,
      }
    case ERROR_SR_DOCUMENT_LOCATION:
      return {
        ...state,
        locationErrors: action.payload,
        lastAction: 'error',
      }
    case UNSET_ERROR_SR_DOCUMENT_LOCATION:
      return {
        ...state,
        locationErrors: {},
      }
    case TOGGLE_SR_DOCUMENT_LOCATION:
      const toggledItem = (state.locationsAvailable[
        action.currentSrDocumentLocation.id
      ] = action.currentSrDocumentLocation)
      toggledItem.is_available = action.payload.toggle
      return {
        ...state,
        lastAction: action.payload.toggle ? 'enable' : 'disable',
        toggledItem,
      }
    case DELETE_SR_DOCUMENT_LOCATION:
      const updated = state.locationsAvailable
      _.unset(updated, `${action.currentSrDocumentLocation.id}`)
      return { ...state, lastAction: 'delete', locationsAvailable: updated }
    default:
      return state
  }
}

export default srDocumentLocationReducer
